import { LogManager } from 'aurelia-framework';
import { ConsoleAppender } from 'aurelia-logging-console';
var config = require('../../../config');
var LogLevel = {
    none: LogManager.logLevel.none,
    error: LogManager.logLevel.error,
    warn: LogManager.logLevel.warn,
    info: LogManager.logLevel.info,
    debug: LogManager.logLevel.debug
};
LogManager.addAppender(new ConsoleAppender());
LogManager.setLevel(LogLevel[config.frameworkLogLevel]);
export var log = LogManager.getLogger(config.portal);
export class LoggerService {
    constructor() {
        this.logger = LogManager.getLogger(config.portal);
    }

    error() {
        this.logger.error.apply(this.logger, arguments);
    }

    warn() {
        this.logger.warn.apply(this.logger, arguments);
    }

    info() {
        this.logger.info.apply(this.logger, arguments);
    }

    debug() {
        this.logger.debug.apply(this.logger, arguments);
    }
}
